import React from 'react';

const Dashboard: React.FC = () => {
  return <div className="card"><h1>Deltaker Dashboard</h1></div>;
};

export default Dashboard;
